import {memo, useMemo} from 'react';
import {forbidExtraProps} from 'airbnb-prop-types';
import {any} from 'prop-types';
import {shuffle} from 'lodash';
import ModalsProvider from './ModalsProvider';
import Layer1 from './Layer1';


export default memo(Providers);

Providers.propTypes = forbidExtraProps({
  children: any.isRequired,
});

function Providers({
  children,
}) {
  return useMemo(
    () => shuffle([
      ModalsProvider,
    ]).reduce(
      (acc, Provider) => (
        <Provider>
          {acc}
        </Provider>
      ),
      (
        <Layer1>
          {children}
        </Layer1>
      ),
    ),
    [],
  );
}
